import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Logger } from '@utils/logger';
import { SelectAllDocs } from '../subscription-manage.interface';
/**
 * Logger
 */
const logger = Logger.getLogger('NameCellRendererComponent');

@Component({
  selector: 'ft-checkbox-cell-renderer',
  templateUrl: './checkbox-cell-renderer.component.html',
  styleUrls: ['./checkbox-cell-renderer.component.scss'],
})
export class CheckboxCellRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  public cellValue: boolean;
  public cellId: string;
  public selectedAll: string;
  public isProductsV2: boolean;

  constructor() {
    // Constructor placeholder
  }

  agInit(params: ICellRendererParams): void {
    this.cellValue = params.value;
    this.cellId = params.data.ID + '-' + params.column.getColId();
    this.params = params;
    this.cellValue = this.getValueToDisplay(params);
    this.params = params;
    // If ID is not defined set random ID.
    this.cellId = params.data.ID || Math.random();
    this.isProductsV2 = params.context.productsV2;
    this.setSelectedAll();
  }

  refresh(params: ICellRendererParams): boolean {
    this.setSelectedAll();
    return true;
  }

  public checkboxChanged($event: boolean) {
    this.params.setValue($event);
    this.params.context.selectionCount(this.cellId);
    logger.debug('Checkbox changed:', $event);
  }

  /**
   * Get Data value to display in template
   * @param params - ICellRendererParams
   */
  private getValueToDisplay(params: ICellRendererParams) {
    return params.value;
  }

  /**
   * Trigger parent parent component selectAllDocs method
   * @param $event - MouseEvent
   */
  public selectAll($event: MouseEvent | boolean) {
    if ($event instanceof MouseEvent) {
      $event.preventDefault();
    }
    const selectAllDocs: SelectAllDocs = {
      dataParams: this.params.data,
    };
    this.params.context.selectAllDocs(selectAllDocs);
    logger.debug('Executed Object:', JSON.stringify(selectAllDocs));
  }

  /**
   * Set SELECT/DESELECT label
   */
  private setSelectedAll(): void {
    const docTypesHeaders = this.params.context.docTypesHeaders();
    this.selectedAll = this.params.context.checkSelectedAll(
      this.params.data,
      docTypesHeaders
    )
      ? 'deselect-all'
      : 'select-all';
  }
}
